import { RevButton, RevDialog } from "@revmatics/catalyst";
import { CreatorBrief } from "../../../stores/types/creatorBriefsTypes";

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  brief: CreatorBrief | null;
  onConfirmDelete: () => void;
  isDeleting: boolean;
};

export const DeleteBriefDialog = ({
  isOpen,
  setIsOpen,
  brief,
  onConfirmDelete,
  isDeleting,
}: Props) => {
  if (!brief) return null;

  const dialogActions = [
    <RevButton
      key="cancel"
      text="No, Cancel"
      variant="secondary"
      handleClick={() => setIsOpen(false)}
    />,
    <RevButton
      key="delete"
      text="Yes, Delete"
      variant="primary"
      buttonColor="error"
      handleClick={onConfirmDelete}
      isLoading={isDeleting}
    />,
  ];

  return (
    <RevDialog
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="Delete Creator Brief?"
      btnList={dialogActions}
    >
      <p className="typography-body-sm text-monochrome-900">
        Are you sure you want to delete the brief "{brief.title}"? This action
        can't be undone.
      </p>
    </RevDialog>
  );
};
